import {MessageComponent} from "./message.component";

export const Message = MessageComponent;
